import React from 'react';
import SEO from '../../../common/SEO';
import Layout from '../../../common/Layout';
import BreadcrumbOne from '../../../common/breadcrumb/BreadcrumbOne';
import RegisterProgramForm from '../../../components/form/register-program-form/RegisterProgramForm';
// import { Link } from 'react-router-dom';

const EventData = [
	{
		"id": 1,
		"title": "AI for Real-Time Speech Accessibility",
		"image": "real_time_speech_accessibility.webp",
		// "website": "https://ovet.app/",
		// "industry": "Healthcare",
		// "rating": "4.8 Google Rating",
		// "duration": "12 Weeks",
		"category": "Healthcare",
		"location": "https://www.skylineinnovation.ca/",
		// "going": "140+",
		"company": "Skyline Innovation"
	}
]

const AIForRealTimeSpeech = ({
	showRegisterForm,
	setShowRegisterForm,
	company
	}) => {
	const eventItem = EventData[0];
	return (
		<>
			<SEO
				title={ eventItem.title }
				description=""
			/>
			<Layout>
				<BreadcrumbOne 
					title={eventItem.title}
					rootUrl="/programs/work-integrated-learning"
					parentUrl="Industry Partner Work Integrated Learning"
					currentUrl={eventItem.title}
				/>
				<div className="edu-event-details-area edu-event-details edu-section-gap bg-color-white">
					<div className="container">
						<div className="row g-5">
							<div className="col-lg-12">
								<div className="thumbnail">
									<img src={`${process.env.PUBLIC_URL}/images/project-details/${ eventItem.image }`} alt="Event Thumb" />
								</div>
							</div>
						</div>
						<div className="row g-5">
							<div className="col-lg-7">
								<div className="content">
									<h3 className="title">{ eventItem.title }</h3>
									<p>
										<strong>What is the main goal for this project?</strong><br></br>
										This project investigates how artificial intelligence can support inclusive communication by improving speech recognition systems for individuals with atypical speech patterns. The goal is to develop an intelligent system that transcribes and enhances speech clarity in real-time, contributing to more accessible and supportive technologies in health and communication contexts.
									</p>
									<p className="mb-0">
										<strong>What tasks will learners need to complete to achieve the project goal?</strong><br></br>
									</p>
									<ul>
										<li>
											Organize and preprocess speech audio data for training and evaluation.
										</li>
										<li>
											Analyze transcription outputs and identify areas for model improvement.
										</li>
										<li>
											Support the benchmarking and testing of speech-to-text pipelines.
										</li>
										<li>
											Assist in deploying APIs for real-time speech recognition services.
										</li>
										<li>
											Contribute to system components that aid in enhancing speech clarity.
										</li>
									</ul>
									<p className="mb-0">
										These tasks help learners build skills at the intersection of AI, accessibility, and digital health.
									</p>
									<p className="mb-0">
										<strong>How will you support learners in completing the project?</strong><br></br>
										Learners will receive structured mentorship from professionals in machine learning and natural language processing. They will have access to curated datasets, development tools, and documentation templates. Weekly check-ins and milestone reviews will ensure steady progress and hands-on experience in building socially impactful AI solutions.
									</p>
								</div>
							</div>
							<div className="col-lg-5">
								<div className="eduvibe-sidebar">
									<div className="eduvibe-widget eduvibe-widget-details">
										<h5 className="title">ABOUT INDUSTRY PARTNER</h5>
										<div className="widget-content">
											<ul>
												{/* <li><span><i className="icon-Campus"></i> { eventItem.company }</span></li> */}
												<li><span><i className="icon-Campus"></i> <a href={eventItem.location}>{ eventItem.company }</a></span></li>
												<li><span><i className="icon-presentation"></i> { eventItem.category }</span></li>
												{/* <li><span><i className="icon-map-pin-line"></i> {company ? <a href={eventItem.location}>Website</a> : eventItem.location}</span></li> */}
												<li>
													Skyline Innovation develops AI-powered apps that support speech therapy for individuals with speech and movement disorders. Their tools offer real-time feedback and correction, making speech practice more accessible and effective. By enabling remote monitoring, Skyline enhances therapy outcomes and empowers users to communicate with greater confidence.
												</li>
											</ul>
											{!company && <div className="read-more-btn mt--45">
												<a className="edu-btn btn-secondary text-center" href="https://form.jotform.com/m2mtech/wil-programs-sign-up">Register Now<i className="icon-arrow-right-line-right"></i></a>
											</div>}
										</div>
									</div>
								</div>
							</div>
							{!company && <div className="col-lg-12">
								<div className="read-more-btn text-center">
									<a className="edu-btn btn-secondary text-center" href="https://form.jotform.com/m2mtech/wil-programs-sign-up">Register Now<i className="icon-arrow-right-line-right"></i></a>
								</div>
							</div>}
						</div>
					</div>
				</div>
			</Layout>
			{showRegisterForm && <RegisterProgramForm setShowRegisterForm={setShowRegisterForm} />}
		</>
	)
}
export default AIForRealTimeSpeech;